import React from 'react'

const Header = () => {
    return (
        <div className='head text-white'>TO-DO APP</div>
    )
}

export default Header